import React, { useMemo } from 'react';
import classNames from 'classnames';
import { SelectCard } from '../SelectCard';
import { FieldRenderProps } from 'react-final-form';
import { BUYER_OUTREACH } from 'models/Listing';
import { BUYER_OUTREACH_DATA } from '../../data';
import { useTranslation } from 'react-i18next';
import FieldWrapper from 'components/FieldWrapper';

import './FieldBuyerOutreach.styles.scss';

type FieldBuyerOutreachProps = {
  className?: string;
  isRequired?: boolean;
  customOnChange?: (value: string) => void;
} & FieldRenderProps<string, HTMLElement>;

const options = Object.values(BUYER_OUTREACH);

const FieldBuyerOutreach: React.FC<FieldBuyerOutreachProps> = (props) => {
  const {
    className,
    isRequired,
    meta: { touched, error },
    input: { value, onChange },
    customOnChange,
  } = props;

  const classes = classNames('field-buyer-outreach', className);

  const { t } = useTranslation();

  const hasError = useMemo(() => touched && error, [error, touched]);

  return (
    <div className={classes}>
      <h1>{t('selectBuyerOutreach')}</h1>

      <FieldWrapper hasError={hasError} error={t('pleaseMakeSelection')}>
        <div className="field-buyer-outreach__cards">
          {options.map((option) => (
            <SelectCard
              key={option}
              isSelected={value === option}
              className={classNames({ error: hasError })}
              onClick={() => {
                const newValue = value === option && !isRequired ? '' : option;
                onChange(newValue);
                customOnChange?.(newValue);
              }}
              {...BUYER_OUTREACH_DATA[option]}
            />
          ))}
        </div>
      </FieldWrapper>
    </div>
  );
};

export default FieldBuyerOutreach;
